import './App.css';
import Header from './Header.js';
import Footer from './Footer.js';
import FloatButton from './Component/Common/FloatButton';

import './css/index.css';
import './css/bootstrap.min.css';
import './css/global.css';
import './css/web.css';
import './css/custom.css';
import './css/fm.css';
import './css/swiper.min.css';
import './css/mobile.css';
import './css/hamimall.css';
import './css/sound_on.css';
import './css/mod.css';
import './css/lullabobby.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//import './js/react_mainJQuery.js';
import {BrowserRouter,Routes,Route} from "react-router-dom"
import {Login,Logout, Company, Main} from './Component/MainPage/index'
import PageContainer from './Component/Common/PageContainer.js'
import CartComponent from './Component/Cart/Cart.js'
import AAA from './Component/AAA/AAA.js'

function App() {
  return (
    <div className="wrapper">
    <BrowserRouter>
      <Header />
      
      <Routes>
       {/* // router 回頭再改動態 */}
       <Route path="/container/:root" element={<PageContainer />} />
       <Route path="/container/:root/:pager" element={<PageContainer />} />
       <Route path="/company/:product" element={<Company />} /> {/*landing page*/}  
       <Route path="/cart/:product" element={<CartComponent />} />
       <Route path="/login" element={<Login />} />
       <Route path="/login/:flag" element={<Login />} />
       <Route path="/logout" element={<Logout />} />
       <Route path="/pay" element={<AAA />} />
       <Route path="/" element={<Main />} />
       <Route path="/:page" element={<Main />} />
       <Route path="/:page/:page2" element={<Main />} />
       <Route path="/:page/:page2/:page3" element={<Main />} />
       <Route path="/campaign/:root" element={<PageContainer />} />
       
     </Routes>
      <Footer />
      <FloatButton />
      </BrowserRouter>
    </div>
    
		
  );
}

export default App;
